import { Grid } from "@mui/material"
import AppBar from "@mui/material/AppBar"
import Tab from "@mui/material/Tab"
import Tabs from "@mui/material/Tabs"
import React, { useState } from "react"
import AdminPackage from "./adminPackage.js"
import AdminService from "./adminService.js"
import LoginPage from "./loginPage.js"

const Admin = ({ authenticated, setAuthenticated }) => {
	const [tab, setTab] = useState(0)

	return (
		<>
			{authenticated === false ? (
				<LoginPage setAuthenticated={setAuthenticated} />
			) : (
				<>
					<AppBar position="relative" color="secondary">
						<Grid justifyContent={"space-between"} container>
							<Grid item>
								<Tabs value={tab} onChange={(_, newValue) => setTab(newValue)}>
									<Tab label="Paketit" id="Tab-paketit" />
									<Tab label="Palvelut" id="Tab-palvelut" />
								</Tabs>
							</Grid>
						</Grid>
					</AppBar>

					{tab === 0 ? <AdminPackage /> : tab === 1 ? <AdminService /> : <></>}
				</>
			)}
		</>
	)
}

export default Admin
